// extracted by css-extract-rspack-plugin
export default {"arrowItem":"_1858a399","isLeft":"_3ee68474","arrow":"_3025078c"};